export default "__VITE_ASSET__poazoXqm__"